@if (showHeader && headerSticky && isScrolled) {
  <header class="header-fixed">
    <skip-nav [buttonBg]="'bg-vis-regular'"></skip-nav>
    <div class="container hidden md:flex items-center !py-4 !px-v-spacing">
      <a href="https://www.aarpdriversafety.org/" title="AARP Driver Safety Course homepage">
        <img
          class="block max-w-none"
          src="https://xgrit-ecom.imgix.net/aarp/AARP-logo-red.png"
          width="153px"
          height="32px"
          alt="aarp logo"
          title="AARP Driver Safety Course homepage"
        />
      </a>
      <div class="container hidden md:flex !py-0 !px-v-spacing">
        <nav aria-label="header-nav" class="flex items-center w-full gap-3 lg:gap-8">
          @for (link of mainHeaderLinks; track link.linkUrl) {
            @if (link.isDropDown) {
              <div class="relative h-full flex items-center"
                (mouseenter)="activeDropdown = link.linkUrl"
                (mouseleave)="activeDropdown = null"
                (focusin)="activeDropdown = link.linkUrl"
                (focusout)="$any($event.currentTarget).contains($event.relatedTarget) ? null : activeDropdown = null">
                <a
                  class="nav-link nav-link-header-sticky gap-1"
                  [href]="link.linkUrl"
                  [class.active]="isDropdownActive(link)"
                  [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
                  aria-haspopup="true"
                  [attr.aria-expanded]="activeDropdown === link.linkUrl ? 'true' : 'false'"
                >
                  {{ link.linkLabel }}
                  <fa-icon class="text-xs text-ace-pink-600" [icon]="activeDropdown === link.linkUrl ? faCaretUp : faCaretDown"></fa-icon>
                </a>
                @if (activeDropdown === link.linkUrl) {
                  <div class="nav-dropdown-panel">
                    @for (item of (link.ddList ?? []); track item.linkUrl) {
                      <a
                        class="nav-dropdown-item"
                        [href]="item.linkUrl"
                        [class.active]="item.linkUrl === currentUrl"
                        [attr.data-formelementid]="item.formElementId ? item.formElementId : null"
                      >
                        {{ item.linkLabel }}
                      </a>
                    }
                  </div>
                }
              </div>
            } @else {
              <a
                class="nav-link nav-link-header-sticky"
                [href]="link.linkUrl"
                [class.active]="link.linkUrl === currentUrl"
                [attr.target]="link.openNewTab ? '_blank' : ''"
                [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
              >
                {{ link.linkLabel }}
              </a>
            }
          }
        </nav>
        <div class="flex items-center desktop-view pl-2 py-2">
          <a
            id="aarp-register-sticky-desktop"
            class="primary-button whitespace-nowrap px-7 h-11"
            [href]="registerLink.linkUrl"
            [attr.data-formelementid]="registerLink.formElementId ? registerLink.formElementId : null"
            aria-label="Register Now from the header"
          >
            {{ registerLink.linkLabel }}
          </a>
        </div>
      </div>
    </div>
    <div class="md:hidden mobile-view">
      <div class="flex justify-between items-center p-4">
        <a href="https://www.aarpdriversafety.org/" title="AARP Driver Safety Course homepage">
          <img
            class="block max-w-none"
            src="https://xgrit-ecom.imgix.net/aarp/AARP-logo-red.png"
            width="153px"
            height="32px"
            alt="aarp logo"
            title="AARP Driver Safety Course homepage"
          />
        </a>
        <a
          id="aarp-register-sticky-mobile"
          class="primary-button whitespace-nowrap px-7 h-11 !text-baselg"
          [href]="registerLink.linkUrl"
          [attr.data-formelementid]="registerLink.formElementId ? registerLink.formElementId : null"
          aria-label="Register Now from the header"
        >
          {{ registerLink.linkLabel }}
        </a>
      </div>

      <div class="flex justify-between items-center px-4 pb-4">
        <nav aria-label="header-nav" class="flex">
          @for (link of mainHeaderLinksStickyNavMobile; track link.linkUrl) {
            <a
              class="nav-link nav-link-header-sticky px-4 whitespace-nowrap !text-base !border-b-0"
              [href]="link.linkUrl"
              [class.active]="link.linkUrl === currentUrl"
              [attr.target]="link.openNewTab ? '_blank' : ''"
              [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
            >
              {{ link.linkLabel }}
            </a>
          }
        </nav>
        <div class="flex items-center desktop-view pl-2">
          <button class="font-semibold pb-[2px]" (click)="showMore = !showMore">
            More
          </button>
          @if (showMore) {
            <nav aria-label="header-nav" class="more-options-nav">
              @for (link of mainHeaderLinksStickyNavMobileMore; track link.linkUrl) {
                <a
                  class="nav-link nav-link-header-sticky px-4 whitespace-nowrap !text-base py-2 !border-b-0"
                  [href]="link.linkUrl"
                  [class.active]="link.linkUrl === currentUrl"
                  [attr.target]="link.openNewTab ? '_blank' : ''"
                  [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
                >
                  {{ link.linkLabel }}
                </a>
              }
            </nav>
          }
        </div>
      </div>
    </div>
  </header>
}

@if (showHeader) {
  <header class="bg-white md:bg-ace-pink-600">
    <skip-nav [buttonBg]="'bg-vis-regular'"></skip-nav>
    <div class="container flex items-center !py-4 !px-v-spacing">
      <a href="https://www.aarpdriversafety.org/" title="AARP Driver Safety Course homepage">
        <img
          class="hidden md:block max-w-none"
          src="https://xgrit-ecom.imgix.net/aarp/AARP-logo-white.png"
          width="153px"
          height="32px"
          alt="aarp logo"
          title="AARP Driver Safety Course homepage"
        />
        <img
          class="md:hidden block max-w-none"
          src="https://xgrit-ecom.imgix.net/aarp/AARP-logo-red.png"
          width="153px"
          height="32px"
          alt="aarp logo"
          title="AARP Driver Safety Course homepage"
        />
      </a>
      <nav aria-label="menu-nav" class="hidden md:flex w-full items-center justify-end text-ace-grey-300 gap-6">
        <a
          class="group flex items-center gap-1"
          [href]="helpLink.linkUrl"
          [attr.data-formelementid]="helpLink.formElementId ? helpLink.formElementId : null"
        >
          <fa-icon class="text-lg" [icon]="faQuestionCircle"></fa-icon>
          <span class="header-button-text">{{ helpLink.linkLabel }}</span>
        </a>
        <a
          class="group flex items-center gap-1"
          [href]="loginLink.linkUrl"
          [attr.target]="loginLink.openNewTab ? '_blank' : ''"
          [attr.data-formelementid]="loginLink.formElementId ? loginLink.formElementId : null"
        >
          <fa-icon class="text-lg" [icon]="faUserCircle"></fa-icon>
          <span class="header-button-text">
            {{ loginLink.linkLabel }}
          </span>
        </a>
      </nav>
      <div class="flex md:hidden flex-col w-full">
        <button class="menu-button flex justify-end items-center gap-1" (click)="toggleMenu()">
          @if (!showMenu) {
            <span class="font-bold text-xs">MENU</span>
          }
          <img
            alt="hamburger-icon"
            [class.hidden]="showMenu"
            [class.block]="!showMenu"
            width="32px"
            height="32px"
            class="w-8 h-8"
            [attr.loading]="'eager'"
            src="https://xgrit-ecom.imgix.net/aarp/AARP_Hamburger_Icon.svg"
          />
          <img
            alt="cross-icon"
            [class.hidden]="!showMenu"
            [class.block]="showMenu"
            width="32px"
            height="32px"
            src="https://xgrit-ecom.imgix.net/aarp/AARP_Cross_Icon.svg"
          />
        </button>
      </div>
    </div>
  </header>
}
@if (showHeader) {
<div class="border-b border-ruler bg-white">
  <div class="container hidden md:flex !py-0 !px-v-spacing">
    <nav aria-label="header-nav" class="flex items-center w-full gap-3 lg:gap-8">
      @for (link of mainHeaderLinks; track link.linkUrl) {
        @if (link.isDropDown) {
          <div class="relative h-full flex items-center"
            (mouseenter)="activeDropdown = link.linkUrl"
            (mouseleave)="activeDropdown = null"
            (focusin)="activeDropdown = link.linkUrl"
            (focusout)="$any($event.currentTarget).contains($event.relatedTarget) ? null : activeDropdown = null">
            <a
              class="nav-link gap-1"
              [href]="link.linkUrl"
              [class.active]="isDropdownActive(link)"
              [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
              aria-haspopup="true"
              [attr.aria-expanded]="activeDropdown === link.linkUrl ? 'true' : 'false'"
            >
              {{ link.linkLabel }}
              <fa-icon class="text-xs text-ace-pink-600" [icon]="activeDropdown === link.linkUrl ? faCaretUp : faCaretDown"></fa-icon>
            </a>
            @if (activeDropdown === link.linkUrl) {
              <div class="nav-dropdown-panel">
                @for (item of (link.ddList ?? []); track item.linkUrl) {
                  <a
                    class="nav-dropdown-item"
                    [href]="item.linkUrl"
                    [class.active]="item.linkUrl === currentUrl"
                    [attr.data-formelementid]="item.formElementId ? item.formElementId : null"
                  >
                    {{ item.linkLabel }}
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <a
            class="nav-link"
            [href]="link.linkUrl"
            [class.active]="link.linkUrl === currentUrl"
            [attr.target]="link.openNewTab ? '_blank' : ''"
            [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
          >
            {{ link.linkLabel }}
          </a>
        }
      }
    </nav>
    <div class="flex items-center desktop-view pl-2">
      <a
        id="aarp-register-header-desktop"
        class="primary-button whitespace-nowrap px-7 h-11"
        [href]="registerLink.linkUrl"
        [attr.data-formelementid]="registerLink.formElementId ? registerLink.formElementId : null"
        aria-label="Register Now from the header"
      >
        {{ registerLink.linkLabel }}
      </a>
    </div>
  </div>
  <div class="container justify-center flex md:hidden gap-3 !pt-2.5 !pb-1 mobile-view">
    <a
      class="!px-4 secondary-button w-full h-11"
      [href]="loginLink.linkUrl"
      [attr.target]="loginLink.openNewTab ? '_blank' : ''"
      [attr.data-formelementid]="loginLink.formElementId ? loginLink.formElementId : null"
    >
      {{ loginLink.linkLabel }}
    </a>
  </div>
  <div class="container flex md:hidden gap-3 !pt-2.5 !pb-6">
    <a
      id="aarp-register-header-mobile"
      class="!px-4 primary-button w-full h-11"
      [href]="registerLink.linkUrl"
      [attr.data-formelementid]="registerLink.formElementId ? registerLink.formElementId : null"
      aria-label="Register Now from the header"
    >
      {{ registerLink.linkLabel }}
    </a>
  </div>
  @if (showMenu) {
    <div class="container h-screen flex flex-col !py-4 border-t bg-white">
      @for (link of mainHeaderLinks; track link.linkUrl) {
        @if (link.isDropDown) {
          <div>
            <div
              class="flex items-center justify-between w-full h-[61px] border-b-2 border-white"
            >
              <a
                class="flex-1 h-full flex items-center"
                [href]="link.linkUrl"
                (click)="toggleMobileDropdown(link, $event)"
                [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
                [attr.aria-expanded]="activeDropdown === link.linkUrl ? 'true' : 'false'"
              >
                {{ link.linkLabel }}
              </a>
              <button
                type="button"
                class="h-full px-4 flex items-center justify-center text-ace-blue-600"
                (click)="toggleMobileDropdownCaret(link)"
                [attr.aria-label]="'Toggle ' + link.linkLabel + ' dropdown'"
              >
                <fa-icon [icon]="activeDropdown === link.linkUrl ? faChevronUp : faChevronDown"></fa-icon>
              </button>
            </div>
            @if (activeDropdown === link.linkUrl) {
              <div class="pl-4 flex flex-col">
                @for (item of (link.ddList ?? []); track item.linkUrl) {
                  <a
                    class="nav-dropdown-mobile-item"
                    [href]="item.linkUrl"
                    [class.active]="item.linkUrl === currentUrl"
                    [attr.data-formelementid]="item.formElementId ? item.formElementId : null"
                  >
                    {{ item.linkLabel }}
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <a
            class="nav-link"
            [href]="link.linkUrl"
            [attr.target]="link.openNewTab ? '_blank' : ''"
            [attr.data-formelementid]="link.formElementId ? link.formElementId : null"
          >
            {{ link.linkLabel }}
          </a>
        }
      }
    </div>
  }
</div>
}
